import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import { Asset } from '../../../../Shared/components/Asset';
import { PartnerCrumbs } from './PartnerCrumbs/PartnerCrumbs';
import styles from './styles.module.css';
import { UserCrumbs } from './UserCrumbs/UserCrumbs';
import { UsersCrumbs } from './UsersCrumbs/UsersCrumbs';

export const Crumb: FC<{ children?: React.ReactNode }> = ({ children }) => (
  <span className={styles.crumb}>{children}</span>
);

export const CrumbDivider: FC = () => (
  <span className={styles.crumbDivider}>
    <Asset variant="chevronRight" />
  </span>
);

export const Breadcrumbs: FC = () => {
  return (
    <div className={styles.wrapper} data-testid="breadcrumbs">
      <Route path="/admin/all-partners">
        <Crumb>Agencies</Crumb>
      </Route>
      <Route path="/admin/moratoriums">
        <Crumb>Moratoriums</Crumb>
      </Route>
      <Route path="/admin/(all-users|users)/:userId?" component={UsersCrumbs} />
      <Route
        path="/admin/partners/:partnerId/:section?/:sectionId?"
        component={PartnerCrumbs}
      />
      <Route path="*/users/create">
        <>
          <CrumbDivider />
          <Crumb>Create New User</Crumb>
        </>
      </Route>
      <Route path="*/users/:userId" component={UserCrumbs} />
    </div>
  );
};
